import React, { useState } from "react";
import { updateCapitalCredentials } from "../../services/authService";

export default function CapitalUpdate({ onUpdated }) {
  const [currentUsername, setCurrentUsername] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");

  const [newUsername, setNewUsername] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    try {
      const res = await updateCapitalCredentials({
        currentUsername,
        currentPassword,
        newUsername,
        newPassword,
      });

      if (res.success) {
        onUpdated();
        return alert(res?.message);
      }
      return alert(
        res.data?.message || "Error occurred while updating the password",
      );
    } catch (err) {
      console.log(err);
      alert(err.response?.data?.message || "Error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} autoComplete="off">
      {/* Hidden dummy fields to prevent autofill */}
      <input type="text" style={{ display: "none" }} />
      <input type="password" style={{ display: "none" }} />

      <h5>Current Credentials</h5>

      <input
        type="text"
        name="current-username"
        placeholder="Current Username"
        className="form-control mb-3"
        value={currentUsername}
        onChange={(e) => setCurrentUsername(e.target.value)}
        required
        autoComplete="new-username"
      />

      <PasswordInput
        value={currentPassword}
        onChange={(e) => setCurrentPassword(e.target.value)}
        placeholder="Current Password"
      />

      <hr />

      <h5>New Credentials</h5>

      <input
        type="text"
        name="new-username"
        placeholder="New Username"
        className="form-control mb-3"
        value={newUsername}
        onChange={(e) => setNewUsername(e.target.value)}
        autoComplete="new-username"
      />

      <PasswordInput
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
        placeholder="New Password"
      />

      <button
        type="submit"
        className="btn btn-warning w-100"
        disabled={loading}
      >
        {loading ? "Updating..." : "Update"}
      </button>
    </form>
  );
}

function PasswordInput({ value, onChange, placeholder }) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="position-relative mb-3">
      <input
        type={showPassword ? "text" : "password"}
        className="form-control"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        autoComplete="new-password"
      />
      <span
        onClick={() => setShowPassword(!showPassword)}
        style={{
          position: "absolute",
          right: "10px",
          top: "50%",
          transform: "translateY(-50%)",
          cursor: "pointer",
          color: "#555",
        }}
      >
        <i
          className={showPassword ? "fa-solid fa-eye-slash" : "fa-solid fa-eye"}
        ></i>
      </span>
    </div>
  );
}
